var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader",class:[{large: _vm.large}, {block: _vm.block}]})
}
var staticRenderFns = []

export { render, staticRenderFns }